import { GenIcon } from 'react-icons';
export const MdLoan = GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 24 24' },
    child: [
        {
            tag: 'path',
            attr: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'M20 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0ZM22 20v-1c0-1.66-1.34-3-3-3h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5ZM5 13v7H3v-7h2Zm14 5.01c.39 0 .74.23.9.56l-5.93 1.84L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19Z',
            },
            child: [],
        },
    ],
});
